module.exports = __webpack_public_path__ + "img/portrait-034.cd856073.jpg";